var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { mapValues } from '@ally/utilitarian';
export function scrubber(options) {
    var allowList = options.allowList, customMask = options.customMask;
    var inner = function (userObject, parentKeys) {
        var _a, _b;
        if (parentKeys === void 0) { parentKeys = []; }
        // handle masking of a single property[shallow]
        var scrubSingle = function (value, key) {
            if (typeof value === 'object' && value !== null) {
                return inner(value, __spread(parentKeys, [key]));
            }
            // Supports dot notation for keys, ie. 'data.status'
            var fullKey = __spread(parentKeys, [key]).join('.').toLowerCase();
            var caseInsensitiveAllowList = allowList.map(function (s) { return s.toLowerCase(); });
            // If key in allowList, return original key-value pair.
            if (caseInsensitiveAllowList.includes(fullKey)) {
                return value;
            }
            // Return custom masking used by internal packages such as transmitigator
            // Else, mask value with default asterisk
            return customMask !== null && customMask !== void 0 ? customMask : '*';
        };
        // handle nested and top-level arrays
        if (Array.isArray(userObject)) {
            var last_1 = (_b = (_a = parentKeys.pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
            // In case of recursion, parentKeys will indicate the depth of the object.
            // top-level, parentKeys = [] and last=''
            return userObject.map(function (item) {
                return scrubSingle(item, last_1 + "[]");
            });
        }
        return mapValues(userObject, scrubSingle);
    };
    return inner;
}
//# sourceMappingURL=scrubber.js.map